import React from 'react';
import { Select, ISelectOption } from '@salecycle/ui-component-library';
import { IClients } from '../../../../../entities';
import { useTranslation } from 'react-i18next';
import { useNewUserDispatch, useNewUserState } from '../../../context/useNewUserContext';
import { getSiteOptions } from 'sections/user-management/utils/helpers';

export interface IProps {
  clients: IClients;
}

export const SiteAccessLevel: React.FC<IProps> = ({ clients }: IProps) => {
  const { t } = useTranslation();
  const { user } = useNewUserState();
  const dispatch = useNewUserDispatch();
  const siteOptions = getSiteOptions(clients);

  const handleSiteChange = (selectedOption: ISelectOption<string>) => {
    dispatch({
      type: 'SET_SELECTED_SITE_VALUE',
      payload: { selectedSite: selectedOption },
    });
  };

  return (
    <Select
      ariaLabel={t('newUser.levels.site')}
      label={t('newUser.levels.site')}
      inputId="SiteSelect"
      onChange={handleSiteChange}
      options={siteOptions}
      value={user.selectedSite}
      clearable={true}
      minLength={3}
      minLengthPlaceholder={t('common.minLengthPlaceholder', {
        minLength: 3,
      })}
      noOptionsPlaceholder={t('common.noOptionsPlaceholder')}
    />
  );
};
